var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1973_749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0716 0.642578H1.92878C1.2187 0.642578 0.643066 1.21821 0.643066 1.92829V9.64258C0.643066 10.3527 1.2187 10.9283 1.92878 10.9283H16.0716C16.7817 10.9283 17.3574 10.3527 17.3574 9.64258V1.92829C17.3574 1.21821 16.7817 0.642578 16.0716 0.642578Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00035 7.71359C10.0655 7.71359 10.9289 6.85014 10.9289 5.78502C10.9289 4.7199 10.0655 3.85645 9.00035 3.85645C7.93523 3.85645 7.07178 4.7199 7.07178 5.78502C7.07178 6.85014 7.93523 7.71359 9.00035 7.71359Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92871 14.1426H16.0716M3.21443 17.3569H14.7859",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1973_749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineMoney);
export default __webpack_public_path__ + "static/media/streamline_money.f30daf36bac5a65399622e31e036c725.svg";
export { ForwardRef as ReactComponent };